import React, { useContext, useState } from "react";
import { Dialog, DialogTitle } from "@mui/material";
import { Container, ButtonDelete, ButtonNonDelete } from "./style";
import UpdateDialog from "../updateDialog";
import { useTranslation } from "react-i18next";
import { ContactContext } from "../../../../context/contact/ContactContext";

const DeleteDialog = ({
  contactUpdate,
  showDialog,
  setShowDialog,
  setUpdateWindow,
}) => {
  const { t } = useTranslation();
  const [success, setSuccess] = useState(false);
  const [dialogUpdate, setShowDialogUpdate] = useState(false);
  const [textTittleUpdateDialog, setTextTittleUpdateDialog] = useState("");
  const { deleteCarrierContact, currentContact } = useContext(ContactContext);

  const handleClose = (e, reason) => {
    if (reason !== "backdropClick" && e.key !== "Escape") {
      setShowDialog(false);
    }
  };

  const handleDelete = async () => {
    setTextTittleUpdateDialog(t("deletingInformation"));
    setShowDialogUpdate(true);
    const resp = await Promise.all([deleteCarrierContact(contactUpdate.id)]);
    console.log(resp);
    setSuccess(true);
    setUpdateWindow((value) => !value);
    // setUpdateWindow(true);

    setTimeout(() => {
      setShowDialogUpdate(false);
    }, 1500);
    setTimeout(() => {
      setShowDialog(false);
    }, 1500);
  };
  return (
    <div>
      {dialogUpdate ? (
        <UpdateDialog
          success={success}
          showDialogUpdate={dialogUpdate}
          setShowDialogUpdate={setShowDialogUpdate}
          // textTittle={t("updatingInformation")}
          textTittle={textTittleUpdateDialog}
        />
      ) : (
        <Dialog
          open={showDialog}
          onClose={(e, reason) => handleClose(e, reason)}
        >
          <Container>
            <DialogTitle>{t("questionContinue")}</DialogTitle>
            <br />
            <ButtonNonDelete onClick={handleClose}>{t("no")}</ButtonNonDelete>
            {"         "}
            <ButtonDelete onClick={handleDelete}>{t("yes")}</ButtonDelete>
          </Container>
        </Dialog>
      )}
    </div>
  );
};
export default DeleteDialog;
